import {ZeroProvider} from '@/shared/integrations/zero/provider'
import {useZero} from '@/shared/integrations/zero/use-zero'
import {useZeroProps} from '@/shared/integrations/zero/use-zero-props'

export {queries} from '@cypro/engine/queries'

export const Zero = {
  Provider: ZeroProvider,
  useProps: useZeroProps,
  useZero: useZero,
}
